import pythonApiClient from './pythonBaseApi';

const menusApi = {
  /**
   * Obtener todas las opciones de menú
   * @param {Object} params - Parámetros de filtrado {activo?, tipo?, parent_id?}
   * @returns {Promise<Array>} - Lista de opciones de menú
   */
  async getMenuOpciones(params = {}) {
    try {
      const response = await pythonApiClient.get('/seguridad/menus/menu-opciones', { params });
      return response;
    } catch (error) {
      console.error('Error al obtener opciones de menú:', error);
      throw error;
    }
  },

  /**
   * Obtener una opción de menú por ID
   * @param {number} menuOpcionId - ID de la opción de menú
   * @returns {Promise<Object>} - Opción de menú
   */
  async getMenuOpcion(menuOpcionId) {
    try {
      const response = await pythonApiClient.get(`/seguridad/menus/menu-opciones/${menuOpcionId}`);
      return response;
    } catch (error) {
      console.error('Error al obtener opción de menú:', error);
      throw error;
    }
  },

  /**
   * Crear una nueva opción de menú
   * @param {Object} menuData - Datos de la opción de menú
   * @returns {Promise<Object>} - Opción de menú creada
   */
  async createMenuOpcion(menuData) {
    try {
      const response = await pythonApiClient.post('/seguridad/menus/menu-opciones', menuData);
      return response;
    } catch (error) {
      console.error('Error al crear opción de menú:', error);
      throw error;
    }
  },

  /**
   * Actualizar una opción de menú
   * @param {number} menuOpcionId - ID de la opción de menú
   * @param {Object} menuData - Datos actualizados
   * @returns {Promise<Object>} - Opción de menú actualizada
   */
  async updateMenuOpcion(menuOpcionId, menuData) {
    try {
      const response = await pythonApiClient.put(`/seguridad/menus/menu-opciones/${menuOpcionId}`, menuData);
      return response;
    } catch (error) {
      console.error('Error al actualizar opción de menú:', error);
      throw error;
    }
  },

  /**
   * Eliminar (desactivar) una opción de menú
   * @param {number} menuOpcionId - ID de la opción de menú
   * @returns {Promise<Object>} - Respuesta del servidor
   */
  async deleteMenuOpcion(menuOpcionId) {
    try {
      const response = await pythonApiClient.delete(`/seguridad/menus/menu-opciones/${menuOpcionId}`);
      return response;
    } catch (error) {
      console.error('Error al eliminar opción de menú:', error);
      throw error;
    }
  },

  /**
   * Obtener opciones de menú asignadas a un rol
   * @param {number} rolId - ID del rol
   * @returns {Promise<Array>} - Lista de opciones de menú del rol
   */
  async getMenuOpcionesRol(rolId) {
    try {
      const response = await pythonApiClient.get(`/seguridad/menus/roles/${rolId}/menu-opciones`);
      return response;
    } catch (error) {
      console.error('Error al obtener opciones de menú del rol:', error);
      throw error;
    }
  },

  /**
   * Asignar opciones de menú a un rol
   * @param {number} rolId - ID del rol
   * @param {Array<number>} menuOpcionIds - Array de IDs de opciones de menú
   * @returns {Promise<Object>} - Respuesta del servidor
   */
  async asignarMenuOpcionesRol(rolId, menuOpcionIds) {
    try {
      const response = await pythonApiClient.post(`/seguridad/menus/roles/${rolId}/menu-opciones`, {
        menu_opcion_ids: menuOpcionIds
      });
      return response;
    } catch (error) {
      console.error('Error al asignar opciones de menú al rol:', error);
      throw error;
    }
  },

  /**
   * Obtener estructura completa del menú en formato árbol
   * @param {number} rolId - ID del rol (opcional, para filtrar por rol)
   * @returns {Promise<Array>} - Estructura de árbol del menú
   */
  async getMenuTree(rolId = null) {
    try {
      const params = rolId ? { rol_id: rolId } : {};
      const response = await pythonApiClient.get('/seguridad/menus/menu-opciones/tree', { params });
      return response;
    } catch (error) {
      console.error('Error al obtener árbol de menú:', error);
      throw error;
    }
  },

  /**
   * Obtener opciones de menú del usuario basadas en sus roles
   * @param {number} userId - ID del usuario
   * @returns {Promise<Array>} - Estructura de árbol del menú del usuario
   */
  async getMenuUsuario(userId) {
    try {
      const response = await pythonApiClient.get(`/seguridad/menus/menu-opciones/usuario/${userId}`);
      return response;
    } catch (error) {
      console.error('Error al obtener menú del usuario:', error);
      throw error;
    }
  }
};

export default menusApi;
